<template>
  <div class="pop-container" @click="onPopUpClick">
    <div class="pop-box">
      <div class="btn-close"><img @click="$emit('close')" src="~images/project/close.svg" /></div>
      <div class="pop-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$blockScroll(true)
  },
  beforeDestroy () {
    this.$blockScroll(false)
  },
  methods: {
    onPopUpClick (e) {
      if (e.target.className.indexOf('pop-container') !== -1) {
        this.$emit('close')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pop-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.5);
  z-index: 1;
}
.pop-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FFF;
  height: 100%;
  max-height: 90%;
  overflow: hidden;

  @media (min-height: 750px) {
    max-height: 750px;
  }

  .btn-close {
    text-align: right;

    img {
      cursor: pointer;
      border-radius: 50%;
      margin: 10px 3% 0 0;
      opacity: 0.7;
      transition: opacity .15s ease-out;
      width: 25px;
      &:hover {
        opacity: 1;
      }
    }
  }

  .pop-content {
    overflow-y: auto;
    overflow-x: hidden;
    width: 94vw;
    height: 88%;
    @media (max-height: 400px) {
      height: 85%;
    }
    @include breakpoint($d_small) {
      width: 100%;
      max-width: 900px;
    }
  }
}
</style>
